export function getType(payload){return Object.prototype.toString.call(payload).slice(8,-1)}export default getType;